import {
  RealworksRelatieSyncType,
  type AppStatus_Realworks_SyncMetadata__Input,
} from '~/graphql/types';
import type { KenmerkLookup } from '../../types';
import transformFrontendKenmerken_FullExcludingKenmerken from '../transformFrontendKenmerken_FullExcludingKenmerken';
import transformFrontendKenmerken_LimitToKenmerken from '../transformFrontendKenmerken_LimitToKenmerken';
import transformFrontendKenmerken_FullSync from '../transformFrontendKenmerken_FullSync';
import { assertNever } from '~/util/assertion';

/**
 * Creates the metadata for the sync type
 */
const generateMetadataForSyncType = ({
  syncType,
  updatedKenmerkLookup,
  relatiesWithoutKenmerken,
}: {
  syncType: RealworksRelatieSyncType;
  updatedKenmerkLookup: KenmerkLookup;
  relatiesWithoutKenmerken: {
    include: boolean;
  };
}): AppStatus_Realworks_SyncMetadata__Input => {
  switch (syncType) {
    case RealworksRelatieSyncType.Full:
      return {
        fullSync: {
          kenmerkMapping:
            transformFrontendKenmerken_FullSync(updatedKenmerkLookup),
        },
      };
    case RealworksRelatieSyncType.LimitToKenmerken:
      return {
        limitToKenmerkenSync: {
          kenmerkMapping:
            transformFrontendKenmerken_LimitToKenmerken(updatedKenmerkLookup),
          relatiesWithoutKenmerken: {
            include: relatiesWithoutKenmerken.include,
          },
        },
      };
    case RealworksRelatieSyncType.FullExcludingKenmerken:
      return {
        fullExcludingKenmerkenSync: {
          kenmerkMapping:
            transformFrontendKenmerken_FullExcludingKenmerken(
              updatedKenmerkLookup,
            ),
        },
      };
    default:
      return assertNever(syncType, 'generateMetadataForSyncType');
  }
};

export default generateMetadataForSyncType;
